import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import { CommonHelper } from 'src/utils/commonHelper';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import TuneIcon from '@mui/icons-material/Tune';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import LanguageIcon from '@mui/icons-material/Language';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Brush as BrushIcon } from '@mui/icons-material';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';

export const applySetupCompletionToMenu = (menuItems = [], setupStatus) => {
  const completeByKey = new Map((setupStatus?.steps || []).map((step) => [step.key, Boolean(step.is_complete)]));

  return menuItems.map((group) => ({
    ...group,
    menu: (group.menu || []).map((item) => {
      const setupKey = item.setupStatusKey;
      if (!setupKey) {
        return item;
      }
      return {
        ...item,
        setupKey,
        setupComplete: completeByKey.get(setupKey) === true,
      };
    }),
  }));
};


export const navSidebar = (translate) => {
  const hasProfessionalTicketPlan = CommonHelper.HasProfessionalPlan();
  return [
     {
      title: translate('navbar.menu.dashboard'),
      menu: [
        {
          title: translate('navbar.menu.analytics', {
            defaultValue: translate('navbar.menu.analytics_dashboard', { defaultValue: 'Analytics' }),
          }),
          path: '/support-analytics',
          icon: <QueryStatsIcon />,
          permissions: `${CommonHelper.PermissionList.ANALYTICS_VIEW}`,
        },
      ],
    },
    // {
    //   title: translate('navbar.menu.widget_setup'),
    //   menu: [
    //     {
    //       title: translate('navbar.menu.widget_setup'),
    //       path: '/widget',
    //       icon: <TuneIcon />,
    //       permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
    //     },
    //   ],
    // },
    // {
    //   title: translate('navbar.menu.faq_setup'),
    //   menu: [
    //     {
    //       title: translate('navbar.menu.faq_setup'),
    //       path: '/faq',
    //       icon: <HelpOutlineIcon />,
    //       permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
    //     },
    //   ],
    // },
    // {
    //   title: translate('navbar.menu.ai_chat_setup'),
    //   menu: [
    //     {
    //       title: translate('navbar.menu.ai_chat_setup'),
    //       path: '/ai-chat',
    //       icon: <SmartToyIcon />,
    //       permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
    //     },
    //   ],
    // },
    
    {
      title: translate('navbar.menu.live_chat'),
      menu: [
        // {
        //   title: translate('navbar.menu.live_chat_setup'),
        //   path: '/live-chat',
        //   icon: <ChatBubbleOutlineIcon />,
        //   permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        // },
        {
          title: translate('navbar.menu.agent_inbox'),
          path: '/agent-inbox',
          icon: <HeadsetMicIcon />,
          permissions: `${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`,
        },
        ...(hasProfessionalTicketPlan
          ? [
              {
                title: translate('navbar.menu.tickets', { defaultValue: 'Tickets' }),
                path: '/tickets',
                icon: <ConfirmationNumberIcon />,
                permissions: `${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`,
              },
            ]
          : []),
        {
          title: translate('navbar.menu.contacts', { defaultValue: 'Contacts' }),
          path: '/contacts',
          icon: <GroupIcon />,
          permissions: `${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.integrations', { defaultValue: 'INTEGRATIONS' }),
      menu: [
        {
          title: translate('navbar.menu.integrations', { defaultValue: 'Integrations' }),
          path: '/integrations',
          icon: <IntegrationInstructionsIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
        {
          title: translate('navbar.menu.whatsapp_chat', { defaultValue: 'WhatsApp Chat' }),
          path: '/whatsapp-chat',
          icon: <WhatsAppIcon />,
          permissions: `${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`,
        },
        {
          title: translate('navbar.menu.facebook_chat', { defaultValue: 'Facebook Chat' }),
          path: '/facebook-chat',
          icon: <FacebookIcon />,
          permissions: `${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`,
        },
        {
          title: translate('navbar.menu.instagram_chat', { defaultValue: 'Instagram Chat' }),
          path: '/instagram-chat',
          icon: <InstagramIcon />,
          permissions: `${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.setup', { defaultValue: 'Setup' }),
      menu: [
        {
          title: translate('navbar.menu.widget_setup'),
          path: '/widget',
          icon: <TuneIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'widget_configured',
        },
        {
          title: translate('navbar.menu.faq_setup'),
          path: '/faq',
          icon: <HelpOutlineIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'faq_ready',
        },
        {
          title: translate('navbar.menu.ai_chat_setup'),
          path: '/ai-chat',
          icon: <SmartToyIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'ai_chat_enabled',
        },
         {
          title: translate('navbar.menu.kb_setup', { defaultValue: 'KB Setup' }),
          path: '/kb-info',
          icon: <LanguageIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'kb_ready',
        },
        {
          title: translate('navbar.menu.kb_setup', { defaultValue: 'KB Setup' }),
          path: '/kb-collections',
          icon: <LanguageIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'kb_ready',
          hide_in_left_pane: true,
        },
        {
          title: translate('navbar.menu.kb_setup', { defaultValue: 'KB Setup' }),
          path: '/kb-articles',
          icon: <LanguageIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'kb_ready',
          hide_in_left_pane: true,
        },
        {
          title: translate('navbar.menu.live_chat_setup'),
          path: '/live-chat',
          icon: <ChatBubbleOutlineIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
          setupStatusKey: 'live_chat_enabled',
        },
        ...(hasProfessionalTicketPlan
          ? [
              {
                title: translate('navbar.menu.ticket_setup', { defaultValue: 'Ticket Setup' }),
                path: '/ticket-setup',
                icon: <ConfirmationNumberIcon />,
                permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
                setupStatusKey: 'ticket_smtp_configured',
              },
            ]
          : []),
      ],
    },
   
  ];
};

export const getSettingsMenu = (translate) => {
  const canShowBranding = CommonHelper.hasWhiteLabelOrCustomDomianAccess();
  return [
    {
      title: translate('navbar.menu.profile'),
      menu: [
        {
          title: translate('profile.general.title'),
          path: '/profile',
          icon: <AccountCircleIcon />,
          permissions: `${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`,
        },
        {
          title: translate('profile.change_password.title'),
          path: '/change-password',
          icon: <VpnKeyIcon sx={{ width: '20px', height: '20px' }} />,
          permissions: `${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`,
        },
        {
          title: translate('profile.profile_details.title'),
          path: '/profile-details',
          icon: <AccountBoxSharpIcon />,
          permissions: `${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`,
        },
        {
          title: translate('menu.coupon_update'),
          path: '/coupon-update',
          hide_in_left_pane: true,
          icon: <ConfirmationNumberIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.brand_settings'),
      menu: [
        {
          title: translate('manage_brand.tabs.brand_info'),
          path: '/manage-brand',
          icon: <AccountBoxSharpIcon />,
          permissions: `${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`,
        },
        {
          title: translate('manage_brand.tabs.manage_roles'),
          path: '/manage-roles',
          icon: <SupervisorAccountIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
        {
          title: translate('manage_brand.tabs.manage_users'),
          path: '/manage-users',
          icon: <ManageAccountsIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
        {
          title: translate('manage_brand.tabs.pending_users'),
          path: '/pending-users',
          icon: <ManageAccountsIcon />,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.manage_organization'),
      menu: [
        {
          title: translate('manage_organization.organization_info.title'),
          path: '/manage-organization',
          icon: <BusinessIcon />,
          permissions: `${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`,
        },
        {
          title: translate('navbar.menu.manage_brand'),
          path: '/manage-org-brands',
          icon: <BuildIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
        {
          title: translate('manage_organization.manage_users_title'),
          path: '/manage-org-users',
          icon: <GroupIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
      ],
    },
    ...(canShowBranding
      ? [
          {
            title: translate('navbar.menu.branding'),
            menu: [
              {
                title: translate('navbar.menu.branding'),
                path: '/branding',
                icon: <BrandingWatermarkIcon />,
                show_in_integsocial_left_pane: true,
                permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
              },
              {
                title: translate('trail_plan.white_label'),
                path: '/white-label',
                icon: <BrushIcon />,
                show_in_integsocial_left_pane: true,
                permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
              },
            ],
          },
        ]
      : []),
    {
      title: translate('navbar.menu.manage_biling'),
      menu: [
        {
          title: translate('navbar.menu.manage_biling'),
          path: '/billing',
          icon: <PaymentIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
          portalAdmin: true,
        },
      ],
    },
    {
      title: translate('navbar.menu.notification_settings'),
      menu: [
        {
          title: translate('navbar.menu.notification_settings'),
          path: '/notification-settings',
          icon: <NotificationsIcon />,
          permissions: `${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`,
        },
      ],
    },
  ];
};

export const navMobilebar = (translate) => {
  const hasProfessionalTicketPlan = CommonHelper.HasProfessionalPlan();
  return [
    { title: translate('navbar.menu.agent_inbox'), path: '/agent-inbox', icon: <HeadsetMicIcon /> },
    ...(hasProfessionalTicketPlan
      ? [
          {
            title: translate('navbar.menu.tickets', { defaultValue: 'Tickets' }),
            path: '/tickets',
            icon: <ConfirmationNumberIcon />,
          },
        ]
      : []),
  ];
};





